import { Actions, Subjects, UISubjects, type CompleteRuleSet } from './abilityTypes'
import { getProjectWithUsersWithStage } from './ruleFunctions'

export const MANAGER_RULES = {
  [Subjects.USER]: () => [],
  [Subjects.USER_DETAIL]: () => [{ actions: [Actions.READ] }],
  [Subjects.ATTENDANCE]: () => [{ actions: [Actions.READ, Actions.WRITE] }],
  [Subjects.CHANGE_MY_PASSWORD]: () => [{ actions: [Actions.WRITE] }],
  [Subjects.PROJECT]: (userId) => [
    { actions: [Actions.READ] },
    {
      actions: [Actions.WRITE],
      condition: (project) => project.isStaged == true || project.userIds?.includes(userId),
      fetch: ({ projectId }) => getProjectWithUsersWithStage(projectId)
    }
  ],
  [Subjects.PROJECT_CREATE]: () => [{ actions: [Actions.WRITE] }],
  [Subjects.PROJECT_USER]: () => [{ actions: [Actions.READ] }],
  [Subjects.PROJECT_SALES_COST]: () => [{ actions: [Actions.READ] }],
  [Subjects.USER_PROJECT]: () => [{ actions: [Actions.READ] }],
  [Subjects.ADD_PROJECT]: () => [{ actions: [Actions.WRITE] }],
  [Subjects.RESOURCE_PLAN]: () => [{ actions: [Actions.READ] }],
  [Subjects.ASSIGN_BY_VOLUMED]: (userId) => [
    {
      actions: [Actions.WRITE],
      condition: (project) => project.isStaged == true || project.userIds?.includes(userId),
      fetch: ({ projectId }) => getProjectWithUsersWithStage(projectId)
    }
  ],
  [Subjects.VOLUMED_ASSIGN]: (userId) => [
    {
      actions: [Actions.WRITE],
      condition: (project) => project.isStaged == true || project.userIds?.includes(userId),
      fetch: ({ projectId }) => getProjectWithUsersWithStage(projectId)
    }
  ],
  [Subjects.CLIENT]: () => [],
  [Subjects.DEPARTMENT]: () => [],
  [Subjects.PARTNER]: () => [],
  [Subjects.JOB_SKILL]: () => [],
  [Subjects.JOB_TITLE]: () => [],
  [Subjects.HOLIDAY]: () => [],
  [Subjects.JOB]: () => [],
  [Subjects.CUSTOM_FIELD]: () => [],
  [Subjects.SETTING]: () => [],

  [UISubjects.PROJECT_LIST_COPY_BUTTON]: (userId) => [
    {
      actions: [Actions.SHOW],
      condition: (project) => project.isStaged == true || project.userIds?.includes(userId),
      fetch: ({ projectId }) => getProjectWithUsersWithStage(projectId)
    }
  ],
  [UISubjects.PROJECT_LIST_DELETE_BUTTON]: (userId) => [
    {
      actions: [Actions.SHOW],
      condition: (project) => project.isStaged == true || project.userIds?.includes(userId),
      fetch: ({ projectId }) => getProjectWithUsersWithStage(projectId)
    }
  ],
  [UISubjects.RESOURCE_PLAN_ADD_USER_BUTTON]: (userId) => [
    {
      actions: [Actions.SHOW],
      condition: (project) => project.isStaged == true || project.userIds?.includes(userId),
      fetch: ({ projectId }) => getProjectWithUsersWithStage(projectId)
    }
  ],
  [UISubjects.RESOURCE_PLAN_PROJECT_PLAN_TABLE_EDIT_ASSIGN]: (userId) => [
    {
      actions: [Actions.SHOW],
      condition: (project) => project.isStaged == true || project.userIds?.includes(userId),
      fetch: ({ projectId }) => getProjectWithUsersWithStage(projectId)
    }
  ],
  [UISubjects.RESOURCE_PLAN_PROJECT_PLAN_TABLE_ADD_BUTTONS]: (userId) => [
    {
      actions: [Actions.SHOW],
      condition: (project) => project.isStaged == true || project.userIds?.includes(userId),
      fetch: ({ projectId }) => getProjectWithUsersWithStage(projectId)
    }
  ],
  [UISubjects.RESOURCE_PLAN_PROJECT_PLAN_TABLE_EDIT_ASSIGN_ICON]: (userId) => [
    {
      actions: [Actions.SHOW],
      condition: (project) => project.isStaged == true || project.userIds?.includes(userId),
      fetch: ({ projectId }) => getProjectWithUsersWithStage(projectId)
    }
  ],
  [UISubjects.PROJECT_SALES_COST_EDIT_BUTTON]: (userId) => [
    {
      actions: [Actions.SHOW],
      condition: (project) => project.isStaged == true || project.userIds?.includes(userId),
      fetch: ({ projectId }) => getProjectWithUsersWithStage(projectId)
    }
  ],
  [UISubjects.PROJECT_SALES_COST_ADD_COST_BUTTON]: (userId) => [
    {
      actions: [Actions.SHOW],
      condition: (project) => project.isStaged == true || project.userIds?.includes(userId),
      fetch: ({ projectId }) => getProjectWithUsersWithStage(projectId)
    }
  ],
  [UISubjects.USER_PROJECT_EDIT_ASSIGN]: (userId) => [
    {
      actions: [Actions.SHOW],
      condition: (project) => project.isStaged == true || project.userIds?.includes(userId),
      fetch: ({ projectId }) => getProjectWithUsersWithStage(projectId)
    }
  ],
  [UISubjects.USER_PROJECT_EDIT_ASSIGN_ICON]: (userId) => [
    {
      actions: [Actions.SHOW],
      condition: (project) => project.isStaged == true || project.userIds?.includes(userId),
      fetch: ({ projectId }) => getProjectWithUsersWithStage(projectId)
    }
  ],
  [UISubjects.PROJECT_USER_ASSIGN_USER]: (userId) => [
    {
      actions: [Actions.SHOW],
      condition: (project) => project.isStaged == true || project.userIds?.includes(userId),
      fetch: ({ projectId }) => getProjectWithUsersWithStage(projectId)
    }
  ],
  [UISubjects.PROJECT_USER_EDIT_ASSIGN_ICON]: (userId) => [
    {
      actions: [Actions.SHOW],
      condition: (project) => project.isStaged == true || project.userIds?.includes(userId),
      fetch: ({ projectId }) => getProjectWithUsersWithStage(projectId)
    }
  ],
  [UISubjects.ADD_PROJECT_EDIT_ASSIGN]: (userId) => [
    {
      actions: [Actions.SHOW],
      condition: (project) => project.isStaged == true || project.userIds?.includes(userId),
      fetch: ({ projectId }) => getProjectWithUsersWithStage(projectId)
    }
  ]
} satisfies CompleteRuleSet
